import { baseRoutes } from "../../../helpers";

const accessRoute = {
  TAXLIST: {
    path: `${baseRoutes.superBaseRoutes}/tax-list`,
  }
};

export default accessRoute;
  